export default __webpack_public_path__ + "static/media/nature.2af9a644.svg";